import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { Raffle } from "@type/Raffle";
import RaffleItem from "@components/RaffleItem";
import Img from "@assets/img";

import * as S from "./style";
import { getRaffle } from "@network/Raffle";
import { SCREEN } from "@type/index";
import { SearchBy } from "@network/Raffle/type";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface Props {
  initData?: Raffle[];
  title?: string;
  type: string;
  screen: SCREEN;
  limit: number;
  searchBy?: SearchBy;
  keyword?: string;
  filter?: string;
  skipFirstItem?: boolean;
}

const RaffleSwiper = ({
  initData,
  title,
  type,
  screen,
  limit,
  searchBy,
  keyword,
  filter,
  skipFirstItem = true,
}: Props) => {
  const [raffleList, setRaffleList] = useState<Raffle[]>(initData ?? []);
  const [isEnd, setIsEnd] = useState<boolean>(false);
  const [pageIndex, setPageIndex] = useState<number>(1);

  const fetch = async () => {
    if (isEnd === true) return;
    const data = {
      limit,
      offset: pageIndex * limit,
      type,
      screen,
      searchBy,
      keyword,
      filter,
    };
    try {
      const response = await getRaffle(data);
      setRaffleList((prev) => [...prev, ...response.data.raffles]);
      if (response.data.raffles.length < limit) {
        setIsEnd(true);
      }
      setPageIndex((prev) => prev + 1);
    } catch (error) {
      console.error("Error fetching images:", error);
    }
  };


  const updateFavoriteList = (raffleId: number) => {
    if (screen !== SCREEN.FAVORITE) return;
    setRaffleList(raffleList.filter((raffle) => raffle.raffleId !== raffleId));
  };

  useEffect(() => {
    if (initData) {
      setRaffleList(initData);
    }
  }, [initData]);

  return (
    <S.SwiperWrapper>
      {raffleList.length > 0 && (
        <>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            {raffleList.length > 1 && <h1>{title}</h1>}
            <div className="navigation-buttons">
              <button className="swiper-button-prev-a">
                <FontAwesomeIcon icon={["fas", "chevron-left"]} />
              </button>
              <button className="swiper-button-next-a">
                <FontAwesomeIcon icon={["fas", "chevron-right"]} />
              </button>
            </div>
          </div>
          <Swiper
            spaceBetween={12}
            slidesPerView={1}
            modules={[Navigation]}
            navigation={{
              nextEl: ".swiper-button-next-a",
              prevEl: ".swiper-button-prev-a",
            }}
            onTransitionEnd={(swiper) => {
              if (swiper.isEnd) {
                fetch();
              }
            }}
            breakpoints={{
              576: {
                slidesPerView: 2,
                spaceBetween: 12,
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 12,
              },
              1024: {
                slidesPerView: 4,
                spaceBetween: 12,
              },
              1440: {
                slidesPerView: 5,
                spaceBetween: 30,
              },
            }}
          >
            {(skipFirstItem ? raffleList.slice(1) : raffleList).map((item) => (
              <SwiperSlide key={item.id} className="h-auto">
                <RaffleItem {...item} updateFavoriteList={updateFavoriteList} screen={screen} />
              </SwiperSlide>
            ))}
          </Swiper>
        </>
      )}
    </S.SwiperWrapper>
  );
};

export default RaffleSwiper;
